import React from 'react';

// Small chip-style leave/home button for top bars and headers.
// confirm: ask before leaving (use on mid-round screens, not lobby/game-over).
const LeaveBtn = ({ onLeave, confirm = false, label = '🏠 LEAVE' }) => {
  if (!onLeave) return null;

  const handleClick = () => {
    if (confirm && !window.confirm('Leave this game?')) return;
    onLeave();
  };

  return (
    <button
      onClick={handleClick}
      style={{
        fontFamily: 'var(--font-display)', fontSize: 11, letterSpacing: 0.5,
        background: 'var(--c-yellow)', color: 'var(--c-ink)',
        border: 'var(--border-ink-sm)', borderRadius: 8,
        padding: '7px 10px', cursor: 'pointer',
        boxShadow: 'var(--shadow-hard-sm)',
        flexShrink: 0, whiteSpace: 'nowrap',
      }}
    >{label}</button>
  );
};

export default LeaveBtn;
